import { render, staticRenderFns } from "./DialogCreatePositionFromDepartment.vue?vue&type=template&id=dbc0059e&scoped=true&"
import script from "./DialogCreatePositionFromDepartment.vue?vue&type=script&lang=js&"
export * from "./DialogCreatePositionFromDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreatePositionFromDepartment.vue?vue&type=style&index=0&id=dbc0059e&lang=scss&scoped=true&"
import style1 from "./DialogCreatePositionFromDepartment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc0059e",
  null
  
)

export default component.exports